import axios from 'axios';

const login = async (credentials) => {
  const apiUrl = process.env.REACT_APP_API_URL || '/api';
  const response = await axios.post(`${apiUrl}/login`, credentials);
  return response.data;
};

const logout = () => {
  window.localStorage.removeItem("loggedBLUser");
  window.location.reload();
};

export default { login, logout };